<template>
	<div class="legend1">
		<p>
			<span class="red"></span>
			{{myabnormalName}}
		</p>
		<p>
			<span class="blue"></span>
			{{mynormalName}}
		</p>
	</div>
</template>
<script>

export default {
  name: 'app',
  data(){
    return {
		mynormalName: this.normalName || "",
		myabnormalName: this.abnormalName || ""
    }
  },
  mounted(){
    
  },
  props:['normalName','abnormalName'],
  methods: {
	
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comss/legendOne.vue